import { MedicationItem } from "../../../../../data-model/drugConfigModel";

export type MedicationClass = "Brand" | "Generic" | "Unknown";
export type MedicationCohort = "Green" | "Orange" | "Unknown";
export type MedicationSource = "manual" | "intelligent_excel_processing";

export interface MedicationListItem extends MedicationItem {
  class?: MedicationClass | string;
  cohort?: MedicationCohort | string;
  name_collision_exclusions?: string[];
  name_replacement?: string;
  replacement_name?: string;
  clinical_questionnaire_rules?: any[];
  related_drugs_count?: number;
  related_drugs_updated_at?: string;
  cleaned_from?: string;
}

export interface MedicationListFilters {
  classes: MedicationClass[];
  cohorts: MedicationCohort[];
  sources: MedicationSource[];
}

export const EMPTY_FILTERS: MedicationListFilters = {
  classes: [],
  cohorts: [],
  sources: [],
};
